// extracted by mini-css-extract-plugin
export default {"icon":"FileFormatIcon_icon__34obj"};